// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"f2b65823","453":"4a7465a5","833":"c397346d"}[chunkId] + ".chunk.js";
};